import { Turbo } from '@hotwired/turbo-rails';
import { preserveTurboCableConnectionState } from '../lib/turbo_cable_stream_source';
import { restoreStreamPermanence } from '../lib/turbo_stream_permanent_elements';

// Ultimate Turbo Modal registers Turbo Stream actions while controllers load,
// so Turbo must be initialized globally before the controller bundle.
import '../controllers';

document.addEventListener('turbo:before-morph-attribute', preserveTurboCableConnectionState);
document.addEventListener('turbo:before-stream-render', restoreStreamPermanence);
Turbo.start()
import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import "@rails/actiontext"


// Import the Bootstrap bundle
//
// This includes Popper and all of Bootstrap's JS plugins.

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css"

// const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
// const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

